document.addEventListener('change', function(event) {
  if (!event.target.matches('[data-product] input[type="radio"]')) return;
  const root = event.target.closest('[data-product]');
  const form = root.querySelector('form');
  const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
  const selected = [...form.querySelectorAll('input[type="radio"]:checked')]
    .sort((a,b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
    .map(input => input.value);
  const variant = variants.find(item => item.options.every((value,index) => value === selected[index]));
  const button = form.querySelector('button[type="submit"]');
  if (!variant) { button.disabled = true; button.textContent = 'Unavailable'; return; }
  form.querySelector('input[name="id"]').value = variant.id;
  button.disabled = !variant.available;
  button.textContent = variant.available ? `Add to bag · ${new Intl.NumberFormat(undefined,{style:'currency',currency:'USD'}).format(variant.price/100)}` : 'Sold out';
});
